import { or, isNil, isEmpty, head } from 'ramda';

export const isNilOrEmpty = (value) => or(isNil(value), isEmpty(value));

export const stringToInt = (value) => Number.parseInt(value, 10);

export const getFirstEntryInArrayAsInteger = (array = []) => {
  return stringToInt(head(array) ?? '-1');
};
